import { Sparkles } from "lucide-react";

// Marcatore riutilizzabile: segnala che un valore è una stima automatica.
export const EstimateBadge = ({ className = "" }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-full border border-amber-500/30 bg-amber-500/15 px-2 py-0.5 text-[10px] font-semibold text-amber-400 ${className}`}
    data-testid="estimate-badge"
  >
    <Sparkles className="h-3 w-3" /> Stima automatica
  </span>
);

// Nota testuale: i dati reali migliorano la stima.
export const EstimateNote = ({ children, className = "" }) => (
  <span className={`text-[11px] leading-tight text-muted-foreground ${className}`} data-testid="estimate-note">
    {children || "Valore stimato automaticamente dai dati di vendita. Inserisci i dati reali per migliorare la stima."}
  </span>
);
